export default __webpack_public_path__ + "media/images/double-fleche2-ecd96500d0c8af47d2fce3edd982278b.png";